import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import { noop, useControlledState, useUniqueId } from '@wp-g2/utils';
import { useCallback, useState } from 'react';
import { Checkbox, Radio } from 'reakit';
import { useFormGroupContext } from '../FormGroup';
import * as styles from './Switch.styles';
var ControlComponent = {
  checkbox: Checkbox,
  radio: Radio
};
export function useSwitch(props) {
  var _useContextSystem = useContextSystem(props, 'Switch'),
      checkedProp = _useContextSystem.checked,
      className = _useContextSystem.className,
      defaultValue = _useContextSystem.defaultValue,
      _useContextSystem$dis = _useContextSystem.disabled,
      disabled = _useContextSystem$dis === void 0 ? false : _useContextSystem$dis,
      idProp = _useContextSystem.id,
      _useContextSystem$isF = _useContextSystem.isFocused,
      isFocusedProp = _useContextSystem$isF === void 0 ? false : _useContextSystem$isF,
      error = _useContextSystem.error,
      _useContextSystem$onB = _useContextSystem.onBlur,
      onBlur = _useContextSystem$onB === void 0 ? noop : _useContextSystem$onB,
      _useContextSystem$onC = _useContextSystem.onChange,
      onChange = _useContextSystem$onC === void 0 ? noop : _useContextSystem$onC,
      _useContextSystem$onF = _useContextSystem.onFocus,
      onFocus = _useContextSystem$onF === void 0 ? noop : _useContextSystem$onF,
      label = _useContextSystem.label,
      _useContextSystem$siz = _useContextSystem.size,
      size = _useContextSystem$siz === void 0 ? 'medium' : _useContextSystem$siz,
      _useContextSystem$typ = _useContextSystem.type,
      type = _useContextSystem$typ === void 0 ? 'checkbox' : _useContextSystem$typ,
      otherProps = _objectWithoutProperties(_useContextSystem, ["checked", "className", "defaultValue", "disabled", "id", "isFocused", "error", "onBlur", "onChange", "onFocus", "label", "size", "type"]);

  var _useState = useState(isFocusedProp),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var _useControlledState = useControlledState(checkedProp, {
    initial: defaultValue || false
  }),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      checked = _useControlledState2[0],
      setChecked = _useControlledState2[1];

  var uniqueId = useUniqueId(useSwitch, 'switch', idProp);

  var _useFormGroupContext = useFormGroupContext(),
      horizontal = _useFormGroupContext.horizontal,
      contextId = _useFormGroupContext.id;

  var Component = ControlComponent[type] || Checkbox;
  var classes = cx(styles.Switch, styles[size], disabled && styles.disabled, contextId && horizontal && styles.formGroup, className);
  var handleOnChange = useCallback(function (event) {
    var next = event.target.checked;
    setChecked(next);
    onChange(next, {
      event: event
    });
  }, [onChange, setChecked]);
  var handleOnBlur = useCallback(function (event) {
    onBlur(event);
    setIsFocused(false);
  }, [onBlur]);
  var handleOnFocus = useCallback(function (event) {
    onFocus(event);
    setIsFocused(true);
  }, [onFocus]);
  return _objectSpread(_objectSpread({}, otherProps), {}, {
    checked: checked,
    className: classes,
    Component: Component,
    id: idProp || contextId || uniqueId,
    disabled: disabled,
    error: error,
    isFocused: isFocused,
    label: label,
    onBlur: handleOnBlur,
    onChange: handleOnChange,
    onFocus: handleOnFocus,
    size: size
  });
}